var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSuggestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.42841 9.33301C2.94474 8.53845 2.6665 7.60751 2.6665 6.61225C2.6665 3.6966 5.05432 1.33301 7.99984 1.33301C10.9454 1.33301 13.3332 3.6966 13.3332 6.61225C13.3332 7.60751 13.0549 8.53845 12.5713 9.33301",
    stroke: "#3D3D43",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.92159 11.3982C4.86034 11.2138 4.82972 11.1216 4.83329 11.0469C4.84083 10.8889 4.94043 10.7502 5.08739 10.693C5.15687 10.666 5.25371 10.666 5.44739 10.666H10.552C10.7456 10.666 10.8425 10.666 10.912 10.693C11.0589 10.7502 11.1585 10.8889 11.1661 11.0469C11.1696 11.1216 11.139 11.2138 11.0778 11.3982C10.9646 11.739 10.908 11.9094 10.8207 12.0474C10.6378 12.3364 10.3511 12.5438 10.02 12.6265C9.86201 12.666 9.68304 12.666 9.3251 12.666H6.67425C6.31631 12.666 6.13734 12.666 5.9793 12.6265C5.64823 12.5438 5.36155 12.3364 5.17867 12.0474C5.09138 11.9094 5.03478 11.739 4.92159 11.3982Z",
    stroke: "#3D3D43"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.666L9.91379 13.0971C9.81951 13.5685 9.77238 13.8041 9.66675 13.9904C9.50344 14.2784 9.23883 14.4953 8.92441 14.599C8.72105 14.666 8.4807 14.666 8 14.666C7.5193 14.666 7.27895 14.666 7.07559 14.599C6.76117 14.4953 6.49656 14.2784 6.33325 13.9904C6.22762 13.8041 6.18049 13.5685 6.08621 13.0971L6 12.666",
    stroke: "#3D3D43"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.6663V7.33301",
    stroke: "#3D3D43",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuggestion);
export default __webpack_public_path__ + "static/media/icon-suggestion.ef7e9d85af4e5fc8629b3fcccd5b69f3.svg";
export { ForwardRef as ReactComponent };